import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { combineReducers } from "@reduxjs/toolkit";
import loadReducers from "../utils/loadReducers";
var authReducers = loadReducers(require.context("./auth", false, /\.slice\.js$/));
var masterReducers = loadReducers(require.context("./master", false, /\.slice\.js$/));
var logicReducers = loadReducers(require.context("./logic", false, /\.slice\.js$/));
var reportReducers = loadReducers(require.context("./report", false, /\.slice\.js$/));
var allReducers = _object_spread({}, authReducers, masterReducers, logicReducers, reportReducers);
var appReducer = combineReducers(allReducers);
var rootReducer = function(state, action) {
    if (action.type === "USER_LOGOUT") {
        return appReducer(undefined, action);
    }
    return appReducer(state, action);
};
export default rootReducer;
